<div class="tw:text-[11px] tw:text-[#888] tw:mb-1.5">Evidence of work</div>

<label
  class="drop-zone tw:items-center tw:justify-center tw:gap-1 tw:border-[1.5px] tw:border-dashed tw:border-[#ccc] tw:rounded tw:py-[14px] tw:px-2.5 tw:cursor-pointer tw:bg-[#fafafa] tw:text-center"
  [class.drag-over]="isDragOver"
  [class.tw:pointer-events-none]="disabled"
  [class.tw:opacity-40]="disabled"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave()"
  (drop)="onDrop($event)">
  <input type="file" class="tw:hidden" [accept]="accept" multiple (change)="onFileSelected($event)" [disabled]="disabled" />
  <span class="tw:text-[20px]">📎</span>
  <span class="tw:text-xs tw:text-[#555] tw:font-semibold">Click to attach or drag &amp; drop</span>
  <span class="tw:text-[10px] tw:text-[#aaa]">Word, PDF, or image files</span>
</label>

@for (message of sizeErrors; track $index) {
  <div class="size-error tw:text-[11px] tw:text-[#c00]" role="alert">{{ message }}</div>
}

@if (files.length > 0) {
  <ul class="file-list tw:list-none tw:p-0 tw:flex tw:flex-col tw:gap-[5px]">
    @for (f of files; track f.name) {
      <li class="tw:flex tw:items-center tw:gap-2 tw:text-xs tw:text-[#333] tw:bg-[#f4f4f4] tw:border tw:border-[#e0e0e0] tw:rounded-[3px] tw:py-[5px] tw:px-2">
        <span class="tw:text-sm tw:flex-shrink-0">{{ fileIcon(f.name) }}</span>
        <span class="tw:flex-1 tw:overflow-hidden tw:text-ellipsis tw:whitespace-nowrap" [title]="f.name">{{ f.name }}</span>
        <span class="tw:text-[#aaa] tw:text-[10px] tw:whitespace-nowrap">{{ formatSize(f.size) }}</span>
        <button mat-icon-button class="remove-btn tw:!w-6 tw:!h-6 tw:![line-height:24px]" (click)="removeFile(f.name)" [disabled]="disabled">
          <mat-icon>close</mat-icon>
        </button>
      </li>
    }
  </ul>
}
